module.exports = __webpack_public_path__ + "img/right-arrow-dark.582171c3.svg";